import {
  AiSystemsForUserDTO,
  InvitationAcceptanceDTO,
  InvitationAcceptanceRequest,
  RegisteredUserDetails,
  RegisteredUsersDTO,
  ResendInvitationDTO,
  SearchUserDTO,
  TeamInvitationsDTO,
  TeamMembersDTO,
  TeamUsersDTO,
  PlatformRole,
  UpdateUserRoleRequest,
  ValidateInvitationResponse
} from '../types/Team.types';
import API from './ApiBase';

export type InviteUserRequest = {
  email: string;
  role: PlatformRole;
};

export type AssignAiSystemToUserRequest = {
  email: string;
  aiSystemGrants: {
    aiSystemId: string;
    role: string;
  }[];
};

export async function inviteUser(params: InviteUserRequest) {
  return await API.post('/ai-systems/team/platform-invitations', params);
}

export async function getTeamUsers() {
  return await API.get<TeamUsersDTO[]>(`/ai-systems/team/users`);
}

export async function getTeamRoles() {
  return await API.get<unknown>('/ai-systems/team/roles');
}

export async function getInvitedTeamMembers(accountId: string) {
  return await API.get<TeamInvitationsDTO>(
    `/accounts/${accountId}/team/invitations`
  );
}

export async function getRegisteredAllMembers(accountId: string) {
  return await API.get<TeamMembersDTO>(`/accounts/${accountId}/team/members`);
}

export async function getRegisteredTeamMembers(
  accountId: string,
  sort?: 'asc' | 'desc'
) {
  return await API.get<RegisteredUsersDTO>(
    `/accounts/${accountId}/members/registered`,
    { params: { sort } }
  );
}

export async function deleteInvitation(
  aiSystemId: string,
  invitationId: string
) {
  return await API.delete<TeamInvitationsDTO>(
    `/ai-systems/${aiSystemId}/team/invitations/${invitationId}`
  );
}

export async function resendInvitation(
  accountId: string,
  invitationId: string
) {
  return await API.post<ResendInvitationDTO>(
    `/accounts/${accountId}/team/invitations/${invitationId}/resend`
  );
}

export async function searchUsers(accountId: string, query: string) {
  return await API.get<SearchUserDTO>(
    `/accounts/${accountId}/team/search-users`,
    {
      params: { q: query }
    }
  );
}

export async function validateInvitation(token: string) {
  return await API.get<ValidateInvitationResponse>(`/invitations/validate`, {
    params: { token }
  });
}

export async function acceptInvitation(
  bodyRequest: InvitationAcceptanceRequest
) {
  return await API.post<InvitationAcceptanceDTO>(
    `/invitations/accept`,
    bodyRequest
  );
}

export async function getAiSystemsForUser(accountId: string, userId: string) {
  return await API.get<AiSystemsForUserDTO>(
    `/accounts/${accountId}/team/members/${userId}/ai-systems`
  );
}

export async function updateUserRoleInAiSystem(
  accountId: string,
  userId: string,
  bodyRequest: UpdateUserRoleRequest
) {
  return await API.patch(
    `/accounts/${accountId}/team/members/${userId}/roles`,
    bodyRequest
  );
}

export async function deleteUserFromSingleAiSystem(
  accountId: string,
  userId: string,
  aiSystemId: string
) {
  return await API.delete(
    `/accounts/${accountId}/team/members/${userId}/ai-systems/${aiSystemId}`
  );
}

export async function deleteUserFromAccount(accountId: string, userId: string) {
  return await API.delete(`/accounts/${accountId}/team/members/${userId}`);
}

export async function assignAiSystemToUserWithoutInvitation(
  accountId: string,
  params: AssignAiSystemToUserRequest
) {
  return await API.post(`/accounts/${accountId}/team/members/assign`, params);
}

export async function searchAiSystemsForUser(
  accountId: string,
  userId: string,
  query: string
) {
  return await API.get<AiSystemsForUserDTO>(
    `/accounts/${accountId}/team/members/${userId}/ai-systems/`,
    {
      params: { q: query }
    }
  );
}
